import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PRODUCTS } from '../../utils/productsData';
import { FaShoppingBag, FaLock } from 'react-icons/fa';

const ProductShowcase = () => {
    const navigate = useNavigate();

    const handleBuy = (product) => {
        navigate('/plataforma/checkout', { state: { product } });
    };

    return (
        <div className="product-showcase">
            <h2 style={{ marginBottom: '1.5rem', color: '#333' }}>Adquira novo conhecimento</h2>
            <div className="card-grid">
                {PRODUCTS.map((product) => (
                    <div key={product.id} className="dashboard-card product-card" style={{ display: 'flex', flexDirection: 'column', padding: '0', overflow: 'hidden' }}>
                        <div style={{ height: '200px', overflow: 'hidden', backgroundColor: '#eee' }}>
                            <img
                                src={product.image}
                                alt={product.title}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        </div>
                        <div style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <h3 className="card-title" style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>{product.title}</h3>
                            <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '1rem', flex: 1 }}>
                                {product.description}
                            </p>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto' }}>
                                <span className="card-value" style={{ fontSize: '1.5rem' }}>
                                    R$ {product.price.toFixed(2).replace('.', ',')}
                                </span>

                                {product.status === 'active' ? (
                                    <button
                                        onClick={() => handleBuy(product)}
                                        className="btn-primary"
                                        style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                                    >
                                        <FaShoppingBag /> Comprar
                                    </button>
                                ) : (
                                    <button
                                        disabled
                                        style={{
                                            backgroundColor: '#ccc',
                                            color: '#666',
                                            border: 'none',
                                            padding: '0.8rem 1.5rem',
                                            borderRadius: '8px',
                                            cursor: 'not-allowed',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.5rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        <FaLock /> Em Breve
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductShowcase;
